import { render, staticRenderFns } from "./similar-decks2.vue?vue&type=template&id=5ae4a3b6"
import script from "./similar-decks2.vue?vue&type=script&lang=js"
export * from "./similar-decks2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports